// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bfb37ac6","239":"bb0f94ff","453":"d7840b84","455":"bbe57898"}[chunkId] + ".chunk.js";
};